import { useSetState } from 'ahooks'
import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import { toJS } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'

import jobStore from '@/store/components/entryJob'

import getQuery from '@/utils/getQuery'

import { HBlockAdd } from '../../HYBVant'

import Popup from './Popup'

import './index.less'
import useAdjustmentRecord from './useAdjustmentRecord'

interface IIncomeTaxDeclaration {
  onConfirm?: (data: any) => void
  isLocalObserver?: boolean
  is_edite?: boolean
  disabled?: boolean
  positionId?: string | null
  value: any[]
}
const IncomeTaxDeclaration: React.FC<IIncomeTaxDeclaration> = ({
  onConfirm,
  isLocalObserver,
  is_edite: is_auth = false,
  disabled = true,
  positionId = null,
  // ...rest,
  value
}) => {
  // console.log('isLocalObserver--->>>', is_auth)
  const staffId = decodeURIComponent(getQuery('staffId') || '')
  const { employeeIds } = useLocalObservable(() => jobStore)
  const staff_Id = employeeIds?.[0] || staffId
  const isAuth: boolean = is_auth
  const [{ socialUserInfos, staffDetail }, setState] = useSetState<{
    socialUserInfos: any[]
    staffDetail: any
  }>({
    socialUserInfos: [],
    staffDetail: {}
  })
  const local = useAdjustmentRecord({
    onConfirm,
    staffDetail,
    staff_Id,
    value,
    socialUserInfos,
    setState
  })
  const {
    add,
    edit,
    open,
    modalData,
    onCancel,
    runSaveSocialSecurityAdjust,
    runDeleteSocialSecurityAdjust,
    saveSocialSecurityAdjustLoading,
    deleteSocialSecurityAdjustLoading
  } = local
  console.log('socialUserInfos', toJS(socialUserInfos))
  return (
    <div className='health_certificate'>
      {!isEmpty(socialUserInfos) && (
        <div className='health_certificate-content-wrapper'>
          {socialUserInfos?.map((x: any, index: number) => (
            <div
              key={x}
              className='health_certificate-content'
              onClick={() => isAuth && edit(index)}
            >
              <div className='health_certificate-content-col-1'>
                <div className='health_certificate-content-1'>
                  {x?.operator_name || '-'}
                  {x?.social_security_status_name ? '(' + x?.social_security_status_name + ')' : ''}
                </div>
                <div className='health_certificate-content-3'>
                  社保生效月份：{x?.social_security_effective_month || '-'}
                </div>
              </div>
              <div className='health_certificate-content-col-2'>
                {isAuth && (
                  <Image
                    className='hyb-com-concat-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={add} text='调整' />}
      {open && (
        <Popup
          visible={open}
          onCancel={onCancel}
          modalData={{
            ...modalData,
            staffDetail,
            staff_Id,
            runSaveSocialSecurityAdjust,
            runDeleteSocialSecurityAdjust,
            saveSocialSecurityAdjustLoading,
            deleteSocialSecurityAdjustLoading
          }}
        />
      )}
    </div>
  )
}

export default observer(IncomeTaxDeclaration)
